(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["doonails-journey"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('doonails-journey-video')) {
    customElements.define('doonails-journey-video', class extends HTMLElement {
      connectedCallback() {
        if (this.abort) return;
        this.abort = new AbortController();
        const options = { signal: this.abort.signal };
        const video = this.querySelector('video');
        const button = this.querySelector('button');
        const sync = () => {
          const playing = !video.paused && !video.ended;
          this.classList.toggle('doonails-journey__player--playing', playing);
          button.setAttribute('aria-pressed', String(playing));
          button.setAttribute('aria-label', playing ? 'Video pausieren' : 'Video abspielen');
        };
        button.addEventListener('click', () => {
          if (video.paused) video.play().catch(sync);
          else video.pause();
        }, options);
        ['play', 'pause', 'ended', 'error'].forEach(event => video.addEventListener(event, sync, options));
        const breakpoint = matchMedia('(min-width: 750px)');
        breakpoint.addEventListener('change', () => video.pause(), options);
        document.addEventListener('visibilitychange', () => {
          if (document.hidden) video.pause();
        }, options);
      }
      disconnectedCallback() {
        this.querySelector('video').pause();
        this.abort?.abort();
        this.abort = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["four-reasons-doonails"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('four-reasons-join-doonails')) {
    customElements.define(
      'four-reasons-join-doonails',
      class extends HTMLElement {
        connectedCallback() {
          if (this.abort) return;
          this.abort = new AbortController();
          const options = { signal: this.abort.signal };
          this.panel = this.querySelector('.four-reasons-join-doonails__sticky');
          this.carousel = this.querySelector('.four-reasons-join-doonails__carousel');
          this.cards = [...this.querySelectorAll('.four-reasons-join-doonails__card')];
          this.reasons = [...this.querySelectorAll('.four-reasons-join-doonails__reason')];
          this.images = [...this.querySelectorAll('.four-reasons-join-doonails__image')];
          this.dots = [...this.querySelectorAll('.four-reasons-join-doonails__dots button')];
          this.desktop = matchMedia('(min-width: 750px)');
          this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
          this.index = 0;
          this.configure = this.configure.bind(this);
          this.schedule = () => {
            if (this.frame) return;
            this.frame = requestAnimationFrame(() => {
              this.frame = 0;
              if (this.dataset.mode !== 'desktop') return;
              const distance = this.offset - this.getBoundingClientRect().top;
              this.select(Math.round(distance / this.step));
            });
          };
          window.addEventListener('scroll', this.schedule, { ...options, passive: true });
          window.addEventListener('resize', this.configure, options);
          window.addEventListener('load', this.configure, options);
          this.desktop.addEventListener('change', this.configure, options);
          this.reduced.addEventListener('change', this.configure, options);
          this.addEventListener(
            'click',
            (event) => {
              const button = event.target.closest('[data-reason-index]');
              if (button) this.go(Number(button.dataset.reasonIndex));
            },
            options
          );
          this.addEventListener(
            'keydown',
            (event) => {
              const button = event.target.closest('.four-reasons-join-doonails__tab');
              if (!button || !['ArrowDown', 'ArrowUp', 'Home', 'End'].includes(event.key)) return;
              event.preventDefault();
              let index = Number(button.dataset.reasonIndex);
              index =
                event.key === 'Home'
                  ? 0
                  : event.key === 'End'
                  ? this.cards.length - 1
                  : index + (event.key === 'ArrowDown' ? 1 : -1);
              index = Math.max(0, Math.min(this.cards.length - 1, index));
              this.reasons[index].querySelector('button').focus({ preventScroll: true });
              this.go(index);
            },
            options
          );
          this.addEventListener(
            'shopify:block:select',
            (event) => {
              const index = this.cards.findIndex((card) => card.dataset.blockId === event.detail.blockId);
              if (index >= 0) {
                if (this.slider) this.slider.select(index);
                else this.select(index);
              }
            },
            options
          );
          this.configure();
          document.fonts?.ready.then(() => {
            if (this.isConnected) this.configure();
          });
        }

        select(index) {
          this.index = Math.max(0, Math.min(this.cards.length - 1, index));
          this.reasons.forEach((reason, i) => {
            const active = i === this.index;
            reason.classList.toggle('is-active', active);
            reason.querySelector('button').setAttribute('aria-expanded', String(active));
            reason.querySelector('[aria-hidden]').setAttribute('aria-hidden', String(!active));
            this.images[i].classList.toggle('is-active', active);
            this.images[i].setAttribute('aria-hidden', String(!active));
            if (this.dots[i]) this.dots[i].setAttribute('aria-current', String(active));
          });
        }

        go(index) {
          if (this.slider) this.slider.select(index);
          else if (
            this.dataset.mode === 'desktop' ||
            this.dataset.mode === 'desktop-static' ||
            this.dataset.mode === 'reduced-desktop'
          ) {
            this.select(index);
            if (this.dataset.mode === 'desktop') {
              const position = this.index ? (this.index - 0.5) * this.step : 0;
              window.scrollTo({
                top: window.scrollY + this.getBoundingClientRect().top - this.offset + position,
                behavior: 'instant',
              });
            }
          } else this.cards[index]?.scrollIntoView({ block: 'nearest', behavior: 'instant' });
        }

        configure() {
          if (!this.cards.length) return;
          const configuredOffset = parseFloat(getComputedStyle(this).getPropertyValue('--reasons-offset')) || 0;
          let headerBottom = 0;
          document
            .querySelectorAll(
              'sticky-header, .header-wrapper, .shopify-section-group-header-group, #shopify-section-header, header'
            )
            .forEach((header) => {
              const position = getComputedStyle(header).position;
              const bottom = header.getBoundingClientRect().bottom;
              if ((position === 'sticky' || position === 'fixed') && bottom > 0)
                headerBottom = Math.max(headerBottom, bottom);
            });
          this.offset = Math.max(configuredOffset, headerBottom, 80);
          this.style.setProperty('--reasons-offset', this.offset + 'px');
          let mode = this.reduced.matches
            ? this.desktop.matches
              ? 'reduced-desktop'
              : 'static'
            : this.desktop.matches
            ? 'desktop'
            : 'mobile';
          if (mode !== 'mobile' && this.slider) {
            this.slider.destroy();
            this.slider = null;
          }
          this.dataset.mode = mode;
          if (mode === 'desktop') {
            this.step = Math.max(280, Math.min(460, window.innerHeight * 0.5));

            const tabHeight = this.reasons.reduce(
              (total, reason) => total + reason.querySelector('button').offsetHeight,
              0
            );
            const detailHeight = Math.max(
              ...this.reasons.map(
                (reason) => reason.querySelector('.four-reasons-join-doonails__detail p').offsetHeight + 20
              )
            );
            const copyHeight = tabHeight + detailHeight + (this.cards.length - 1) * 20;
            const imageHeight = this.querySelector('.four-reasons-join-doonails__images').offsetHeight;
            const style = getComputedStyle(this.panel);
            const header = this.querySelector('.four-reasons-join-doonails__header');
            const panelHeight =
              header.offsetHeight +
              32 +
              Math.max(copyHeight, imageHeight) +
              parseFloat(style.paddingTop) +
              parseFloat(style.paddingBottom);

            if (this.cards.length < 2) {
              this.dataset.mode = 'desktop-static';
              this.style.removeProperty('--reasons-panel');
              this.style.removeProperty('--reasons-runway');
            } else {
              /*
               * --reasons-panel is the minimum content height. The CSS takes
               * max(panel, viewport - offset), so the pinned panel always fills
               * the screen and the runway never shows as empty space below it.
               */
              this.style.setProperty('--reasons-panel', panelHeight + 'px');

              const finalReasonStart = Math.max(0, (this.cards.length - 1.5) * this.step);
              this.style.setProperty('--reasons-runway', finalReasonStart + 'px');

              this.schedule();
            }
          } else if (mode === 'mobile' && !this.slider && window.Flickity) {
            this.slider = new Flickity(this.carousel, JSON.parse(this.carousel.getAttribute('flickity-config')));
            this.slider.on('change', (index) => this.select(index));
            this.slider.select(this.index, false, true);
          }
          if (mode === 'mobile' && !this.slider) this.dataset.mode = 'static';
          if (this.slider) this.slider.resize();
          this.select(this.index);
        }

        disconnectedCallback() {
          this.abort?.abort();
          this.slider?.destroy();
          cancelAnimationFrame(this.frame);
          this.abort = null;
          this.slider = null;
        }
      }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
